// ── Shared Zensibly brand logo ──────────────────────────────────────────────
// Single source for the wordmark. Replaces the old ◆ + "Cockpit" block that was
// duplicated verbatim across 11 island headers.
//
// Wordmark (Space Grotesk 700, letter-spacing -0.03em):
//   "Zen"   — sits in a solid accent pill (bg var(--accent), ink var(--accent-ink))
//   "sibly" — var(--text), same 700 weight
// Tagline (JetBrains Mono 500, uppercase, wide-tracked, var(--muted)).
// All metrics are em/ratio-based off `size` (the wordmark font-size in px), so the
// pill, tagline and spacing scale together and the colours flip with the theme.
//
// Usage:
//   <Brand />            header wordmark (20px)
//   <Brand size={54} />  large display lockup
//   <Brand size={54} tagline />  lockup + "TRADE SENSIBLY"
import React from 'react';

export default function Brand({ size = 20, tagline = false, style, className }) {
    return (
        <span
            className={className}
            aria-label="Zensibly"
            style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1, ...style }}
        >
            <span
                style={{
                    fontFamily: "'Space Grotesk', system-ui, -apple-system, sans-serif",
                    fontWeight: 700,
                    fontSize: size,
                    letterSpacing: '-0.03em',
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                }}
            >
                <span style={{ background: 'var(--accent)', color: 'var(--accent-ink)', padding: '0.04em 0.24em', borderRadius: '0.2em' }}>Zen</span>
                <span style={{ color: 'var(--text)', marginLeft: '0.1em' }}>sibly</span>
            </span>

            {tagline && (
                <span
                    style={{
                        fontFamily: "'JetBrains Mono', ui-monospace, monospace",
                        fontWeight: 500,
                        fontSize: Math.max(11, Math.round(size * 0.24)),
                        letterSpacing: '0.36em',
                        textTransform: 'uppercase',
                        color: 'var(--muted)',
                        marginTop: Math.round(size * 0.37),
                        whiteSpace: 'nowrap',
                    }}
                >
                    Trade Sensibly
                </span>
            )}
        </span>
    );
}
